import CardHeader from "components/CardHeader";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import { UserDevice } from "models/User";
import React from "react";
import { Card, CardBody } from "reactstrap";

interface Props {
    devices: readonly UserDevice[];
}

const DevicesAndSessions: React.FC<Props> = ({ devices }) => {
    const { intlLocale, t } = useOfficeTranslation();

    return <Card>
        <CardBody>
            <CardHeader
                title={t("user.userDetail.devicesAndSessions")}
                icon="mdi-devices"
                count={devices.length}
            />
            {devices.length === 0
                ? <p className="text-muted mt-3 mb-0">{t("user.userDetail.noActiveSessionsFound")}</p>
                : <div className="table-responsive mt-3">
                    <table className="table align-middle mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>{t("user.userDetail.device")}</th>
                                <th>{t("user.userDetail.ipAddress")}</th>
                                <th>{t("user.userDetail.signedIn")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {devices.map(device => <tr key={device.id}>
                                <td className="text-break">
                                    {device.user_agent === ""
                                        ? <span className="text-muted">{t("user.userDetail.noBrowserInformationStored")}</span>
                                        : device.user_agent}
                                </td>
                                <td className="text-nowrap">
                                    {device.ip_address === ""
                                        ? <span className="text-muted">{t("user.userDetail.noIpAddressStored")}</span>
                                        : device.ip_address}
                                </td>
                                <td className="text-nowrap">
                                    <time dateTime={device.created}>
                                        {new Date(device.created).toLocaleString(intlLocale)}
                                    </time>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>}
        </CardBody>
    </Card>;
};

export default DevicesAndSessions;
